export const enum MutationNames {
  updateExercises = 'EXERCISE_UPDATE_EXERCISES',
  updateExercise = 'EXERCISE_UPDATE_EXERCISE',
  addExercise = 'EXERCISE_ADD_EXERCISE',
  setTimer = 'EXERCISE_SET_TIMER',
  clearTimer = 'EXERCISE_CLEAR_TIMER',
  setLoading = 'EXERCISE_SET_LOADING',
}

export const enum ActionNames {
  getExercises = 'EXERCISE_GET_EXERCISES',
  getExercisesByPatient = 'EXERCISE_GET_EXERCISES_BY_PATIENT',
  updateExercise = 'EXERCISE_UPDATE_EXERCISE',
  postExercise = 'EXERCISE_POST_EXERCISE',
  patchExercise = 'EXERCISE_PATCH_EXERCISE',
  deleteExercise = 'EXERCISE_DELETE_EXERCISE',
}

export const enum GetterNames {
  exercisesForList = 'EXERCISE_EXERCISES_FOR_LIST',
  exercise = 'EXERCISE_EXERCISE',
  exercises = 'EXERCISE_EXERCISES',
  sortedExercises = 'EXERCISE_SORTED_EXERCISES',
}
